import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import Products from '../../Models/Products';
import { withRouter } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
class Cart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
            productDetails: [],
            sellerDetails: '',
            estimation: '',
            autoPayment: '',
            modal: { 1: false, 2: false },
        };
        console.log(this.props.state)
        this.getDetails(this.props.state.id);
        this.getSellerDetails();
        this.getEstimation(this.props.state.id);
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        console.log(this.state.productDetails)
    }

    toggle(i) {
        let s = this.state.modal;
        s[i] = !s[i];
        this.setState({ modal: s })
    }

    getDetails(id) {
        Products.getProductsDetails(id).then(res => {
            this.setState({ productDetails: res.data.product })
        })
        console.log(this.state.productDetails)
    }

    getEstimation(id) {
        Products.getProductsDetails(id).then(res => {
            res.data.product.map(res =>
                this.setState({ estimation: res.is_estimate_or_customizable, autoPayment: res.renewal_type })
            )
        })
    }

    getSellerDetails() {
        Products.getProductsDetails(this.props.state.id).then(res => {
            res.data.seller.map(res =>
                this.setState({ sellerDetails: res.id })
            )
        })
    }

    autoPayment() {
        if (this.state.autoPayment == 2) {
            return (
                <span style={{fontSize:"12px"}}>(継続課金)</span>
            )
        }else{
            return(
                <span></span>
            )
        }
    }

    openLink() {
        var hexString = (this.props.state.id + 521).toString(16);
        this.props.history.push({
            pathname: `/payment/${this.props.state.id}`,
            state: { id: this.props.state.id, flag: 'product' }
        });
    }
    //estimation
    askEstimation() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            if (!localStorage.getItem('info')) {
                return (
                    <div className="pt-3" style={{ borderTop: '1px solid #ccc' }}>
                        <div style={{ textAlign: 'center' }} >
                            <Button className="mb-3" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>見積り・相談する</Button>
                            <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                                <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                                <ModalBody>
                                    ログインしてください。
                        </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    </div>
                )
            } else {
                if (this.state.estimation === 'YES') {
                    var x = JSON.parse(localStorage.getItem('info'))
                    if (x.id === this.state.sellerDetails) {
                        return (
                            <div className="pt-3" style={{ borderTop: '1px solid #ccc' }}>
                                <div style={{ textAlign: 'center' }} >
                                    <Button className="mb-3" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 2)}>見積り・相談する</Button>
                                    <Modal isOpen={this.state.modal[2]} toggle={this.toggle.bind(this, 2)} className={this.props.className}>
                                        <ModalHeader toggle={this.toggle.bind(this, 2)}></ModalHeader>
                                        <ModalBody>
                                            自分自身への見積り相談は行なえません！
                                </ModalBody>
                                        <ModalFooter>
                                            <Button color="danger" onClick={this.toggle.bind(this, 2)}>閉じる</Button>
                                        </ModalFooter>
                                    </Modal>
                                </div>
                            </div>
                        )
                    } else {
                        return (
                            <div className="pt-3" style={{ borderTop: '1px solid #ccc' }}>
                                <div className="" style={{ textAlign: 'center' }}>
                                    <Link to={{
                                        pathname: `/buyer-ask-estimate/${this.props.state.id}`,
                                        state: { id: this.props.state.id }
                                    }} className="payment_order mb-3">
                                        <button type="submit" className="btn mb-3" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} > 見積り・相談する </button>
                                    </Link>
                                </div>
                            </div>
                        )
                    }
                } else if (this.state.estimation === 'NO') {
                    return (
                        <div></div>
                    )
                }
            }
        } else if (isDesktop) {
            if (!localStorage.getItem('info')) {
                return (
                    <div className="pt-3" style={{ borderTop: '1px solid #ccc' }}>
                        <div style={{ textAlign: 'center' }} >
                            <Button className="mb-3" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>見積り・相談する</Button>
                            <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                                <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                                <ModalBody>
                                    ログインしてください。
                        </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    </div>
                )
            } else {
                if (this.state.estimation === 'YES') {
                    var x = JSON.parse(localStorage.getItem('info'))
                    if (x.id === this.state.sellerDetails) {
                        return (
                            <div className="pt-3" style={{ borderTop: '1px solid #ccc' }}>
                                <div style={{ textAlign: 'center' }} >
                                    <Button className="mb-3" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 2)}>見積り・相談する</Button>
                                    <Modal isOpen={this.state.modal[2]} toggle={this.toggle.bind(this, 2)} className={this.props.className}>
                                        <ModalHeader toggle={this.toggle.bind(this, 2)}></ModalHeader>
                                        <ModalBody>
                                            自分自身への見積り相談は行なえません！
                                </ModalBody>
                                        <ModalFooter>
                                            <Button color="danger" onClick={this.toggle.bind(this, 2)}>閉じる</Button>
                                        </ModalFooter>
                                    </Modal>
                                </div>
                            </div>
                        )
                    } else {
                        return (
                            <div className="pt-3" style={{ borderTop: '1px solid #ccc' }}>
                                <div className="text-center">
                                    <Link to={{
                                        pathname: `/buyer-ask-estimate/${this.props.state.id}`,
                                        state: { id: this.props.state.id }
                                    }} className="payment_order mb-3" style={{ textAlign: 'center' }} >
                                        <button type="submit" className="btn mb-3" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} > 見積り・相談する </button>
                                    </Link>
                                </div>
                            </div>
                        )
                    }
                } else if (this.state.estimation === 'NO') {
                    return (
                        <div >

                        </div>
                    )
                }
            }
        }
    }
    //payment
    gotoPayment() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            console.log('asd');
            if (!localStorage.getItem('info')) {
                return (
                    <div className="pb-3" style={{ textAlign: 'center' }}>
                        <Button className="" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>購入画面に進む</Button>
                        <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                            <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                            <ModalBody>
                                ログインしてください。
                        </ModalBody>
                            <ModalFooter>
                                <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                )
            } else {
                var x = JSON.parse(localStorage.getItem('info'))
                if (x.id === this.state.sellerDetails) {
                    return (
                        <div className="pb-3" style={{ textAlign: 'center' }} >
                            <Button className="" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>購入画面に進む</Button>
                            <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                                <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                                <ModalBody>
                                    自分が出品したサービスは購入出来ません！
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    )
                } else if (this.props.state.available > 0) {
                    return (
                        <div className="pb-3" style={{ textAlign: 'center' }}>
                            <button type="submit" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.openLink.bind(this)}>購入画面に進む </button>
                            
                        </div>
                    )
                } else {
                    return (
                        <div className="pb-3" style={{ textAlign: 'center' }}>
                            <Button className="" style={{ textAlign: 'center', width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>購入画面に進む</Button>
                            <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                                <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                                <ModalBody>
                                    現在は取り扱いしておりません。
                            </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    )
                }
            }
        } else if (isDesktop) {
            console.log('sad');
            if (!localStorage.getItem('info')) {
                return (
                    <div className="pb-3" style={{ textAlign: 'center' }} >
                        <Button className="" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>購入画面に進む</Button>
                        <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                            <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                            <ModalBody>
                                ログインしてください。
                        </ModalBody>
                            <ModalFooter>
                                <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                )
            } else {
                var x = JSON.parse(localStorage.getItem('info'))
                if (x.id === this.state.sellerDetails) {
                    return (
                        <div className="pb-3" style={{ textAlign: 'center' }}>
                            <Button className="" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>購入画面に進む</Button>
                            <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                                <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                                <ModalBody>
                                    自分が出品したサービスは購入出来ません！
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    )
                } else if (this.props.state.available > 0) {
                    return (
                        <div className="pb-3" style={{ textAlign: 'center' }}>
                            <button type="submit" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.openLink.bind(this)}>購入画面に進む </button>
                            
                        </div>
                    )
                } else {
                    return (
                        <div className="pb-3" style={{ textAlign: 'center' }} >
                            
                            <Button className="" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>購入画面に進む</Button>
                            <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                                <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                                <ModalBody>
                                    現在は取り扱いしておりません。
                            </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    )
                }
            }
        }
    }

    render() {
        return (
            <div>
                <div className="cart_inner">
                    <div className="cart_option">
                        <div className="payment_price mt-1">
                            {this.state.productDetails.map(res =>
                            <div className="">
                                <b key={res.price}>{parseInt(res.price)} 円 </b>{this.autoPayment()}
                            </div>
                            )}
                        </div>
                        <div className="payment_points mt-2"></div>
                        {this.gotoPayment()}
                        {/* <hr /> */}
                        {this.askEstimation()}
                        <div className="payment_points "></div>
                    </div>
                </div>
            </div>
        )
    }
}
Cart = withRouter(Cart)
export { Cart } 